import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
    Box,
    Tabs,
    Tab,
    Container,
    alpha,
    useTheme
} from '@mui/material';
import {
    PostAdd as PostAddIcon,
    CalendarMonth as CalendarMonthIcon
} from '@mui/icons-material';
import PostContent from '../components/PostContent';
import CalendarView from '../components/calendar/CalendarView';
import SEO from '../components/SEO';

const PostManagementPage = ({ onPost, error }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const theme = useTheme();

    // Determine active tab from path or state
    const getTabValue = () => {
        if (location.pathname.startsWith('/app/calendar')) return 1;
        return 0; // default to posting
    };

    const [value, setValue] = useState(getTabValue());

    useEffect(() => {
        setValue(location.pathname.startsWith('/app/calendar') ? 1 : 0);
    }, [location.pathname]);

    const handleChange = (event, newValue) => {
        setValue(newValue);
        if (newValue === 0) {
            navigate('/app/post');
        } else {
            navigate('/app/calendar');
        }
    };

    return (
        <Box sx={{ width: '100%', minHeight: '100vh', bgcolor: 'background.default' }}>
            <SEO
                title={value === 0 ? "Post Content | Socialixer" : "Content Calendar | Socialixer"}
                description={value === 0 ? "Publish to multi-platforms simultaneously." : "Manage your content schedule."}
                path={value === 0 ? "/app/post" : "/app/calendar"}
                noIndex
            />

            <Box sx={{
                position: 'sticky',
                top: 0,
                zIndex: 10,
                bgcolor: alpha(theme.palette.background.paper, 0.8),
                backdropFilter: 'blur(8px)',
                borderBottom: 1,
                borderColor: 'divider',
                mb: 3
            }}>
                <Container maxWidth="xl">
                    <Tabs
                        value={value}
                        onChange={handleChange}
                        aria-label="post management tabs"
                        sx={{
                            '& .MuiTabs-indicator': {
                                height: 3,
                                borderRadius: '3px 3px 0 0',
                            },
                            '& .MuiTab-root': {
                                textTransform: 'none',
                                fontWeight: 700,
                                fontSize: '0.95rem',
                                minWidth: 160,
                                minHeight: 64,
                                color: 'text.secondary',
                                '&.Mui-selected': {
                                    color: 'primary.main',
                                },
                            }
                        }}
                    >
                        <Tab
                            icon={<PostAddIcon sx={{ fontSize: 20 }} />}
                            iconPosition="start"
                            label="Multi-Platform Posting"
                            data-testid="tab-posting"
                        />
                        <Tab
                            icon={<CalendarMonthIcon sx={{ fontSize: 20 }} />}
                            iconPosition="start"
                            label="Calendar View"
                            data-testid="tab-calendar"
                        />
                    </Tabs>
                </Container>
            </Box>

            <Container maxWidth="xl">
                <Box sx={{ py: 1 }}>
                    {value === 0 ? (
                        <PostContent onPost={onPost} error={error} />
                    ) : (
                        <CalendarView />
                    )}
                </Box>
            </Container>
        </Box>
    );
};

export default PostManagementPage;
